export const preparerIdentifications = {
  veteran: 'VETERAN',
  survivingDependent: 'SURVIVING_DEPENDENT',
  thirdPartyVeteran: 'THIRD_PARTY_VETERAN',
  thirdPartySurvivingDependent: 'THIRD_PARTY_SURVIVING_DEPENDENT',
};

export const veteranBenefits = {
  COMPENSATION: 'compensation',
  PENSION: 'pension',
};

export const survivingDependentBenefits = {
  SURVIVOR: 'survivor',
};

export const submissionApis = {
  BENEFITS_INTAKE: 'benefitsIntake', // benefits intake - async
  INTENT_TO_FILE: 'intentToFile', // benefits claims - syncronous
};
